import MuiAccordion from "@mui/material/Accordion";
import { styled } from "@mui/system";
import { MDXRemote } from "next-mdx-remote";
import { useEffect, useState } from "react";
import { convertMDX } from "utils/mdx";

import { AccordionSummary } from "../onboardingSections/inputs";

import styles from "@/styles/document.module.scss";

const Document = ({ data }) => {
  const [state, setState] = useState(null);
  const [expanded, setExpanded] = useState(0);
  useEffect(() => {
    async function setData() {
      const source = data.documents.data?.[expanded]
        ? data.documents.data[expanded].attributes.content.replace("<br>", " ")
        : "";
      const mdxSource = await convertMDX(source, false);
      setState(mdxSource);
      if (expanded !== false) scrollToTop(expanded);
    }
    if (expanded !== false) {
      setData();
    }
    if (data.documents.data.length <= 1) {
      setData();
    }
  }, [expanded, data.documents.data]);

  const scrollToTop = index => {
    const panelElm = document.getElementById("panel" + index);
    panelElm?.scrollIntoView();
  };

  const DocsAccordion = styled(props => (
    <MuiAccordion disableGutters elevation={0} {...props} />
  ))(({ theme }) => ({
    borderBottom: "1px solid #C4C4C4",
    backgroundColor: "",
    width: "100%",
    borderRadius: "0px !important",
    "&:before": {
      display: "none",
    },
  }));

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : 0);
  };

  return (
    <div className="max-w-1420 mx-auto w-full p-7 md:p-20">
      {data.documents.data.length > 1 ? (
        data.documents.data.map((v, i) => (
          <DocsAccordion
            key={i}
            expanded={expanded === i}
            onChange={handleChange(i)}
          >
            <AccordionSummary aria-controls={`panel${i}`} id={`panel${i}`}>
              <p className={styles.accordionTitle}>{v.attributes.shortName}</p>
            </AccordionSummary>
            <div className={styles.content}>
              {state === null ? null : <MDXRemote {...state} />}
            </div>
          </DocsAccordion>
        ))
      ) : state === null ? null : (
        <div className={styles.content}>
          <MDXRemote {...state} />
        </div>
      )}
    </div>
  );
};

export default Document;
